import React, { useEffect, useRef } from 'react'
import { TextField } from '@material-ui/core'

let autoComplete

function handleScriptLoad(updateQuery, updateInfo, autoCompleteRef) {
  // assign autoComplete with Google maps place one time
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { componentRestrictions: { country: 'cl' } },
  )
  autoComplete.setFields() // specify what properties we will get from API
  // add a listener to handle when the place is selected
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery, updateInfo),
  )
   
}

async function handlePlaceSelect(updateQuery, updateInfo) {
   
  const addressObject = autoComplete.getPlace()
  const latitud = addressObject.geometry.location.lat()
  const longitud = addressObject.geometry.location.lng()
  const {
    address_components,
    adr_address,
    formatted_address,
    html_attributions,
    icon,
    name,
    place_id,
    reference,
    url,
    utc_offset_minutes,
    vicinity,
  } = addressObject

  const fixedLocationObject = {
    address_components: address_components ? address_components : '',
    adr_address: adr_address ? adr_address : '',
    formatted_address: formatted_address ? formatted_address : '',
    html_attributions: html_attributions ? html_attributions : '',
    icon: icon ? icon : '',
    name: name ? name : '',
    place_id: place_id ? place_id : '',
    reference: reference ? reference : '',
    url: url ? url : '',
    utc_offset_minutes: utc_offset_minutes ? utc_offset_minutes : '',
    vicinity: vicinity ? vicinity : '',
    geometry: {
      lng: longitud,
      lat: latitud,
    },
  }

  const query = addressObject.formatted_address
  updateQuery(query)
  updateInfo(fixedLocationObject)
}

const SearchLocationInpunt = ({
  setAddress,
  helperText,
  locationString,
  setLocationString,
  isValid,
}) => {
  const autoCompleteRef = useRef(null)
  useEffect(() => {
    handleScriptLoad(setLocationString, setAddress, autoCompleteRef)
  }, [])
  const handleOnChange = (newValue) => {
    setLocationString(newValue)
  }

  return (
    <TextField
      error={!isValid}
      helperText={helperText && `El tiempo aprox. es de ${helperText}`}
      inputRef={autoCompleteRef}
      placeholder="Indique su dirección"
      label="Dirección"
      variant="outlined"
      style={{ marginBottom: '1.5rem' }}
      value={locationString}
      onChange={(event) => handleOnChange(event.target.value)}
    />
  )
}

export default SearchLocationInpunt
